import { ENVIRONMENT } from '../../../enviroment/enviroment';
import type { AssignDriverPayload } from '../../models/assign-driver';
import type { Profile } from '../../models/profile';
import type { PricingSettings } from '../../models/settings';

export interface ViewsState {
  profileImage: File | string;
  profile?: Profile;
  pricingSettings: PricingSettings;
  isAssignDriverOpen: boolean;
  assignDriverBooking: AssignDriverPayload;
  // Map of list feature key to selected tab key (e.g., { vehicleManagement: 'available' })
  selectedListTabs?: Record<string, string | null>;
}

export const INITIAL_VIEWS_STATE: ViewsState = {
  profileImage: ENVIRONMENT.ANGULAR_APP_DEFAULT_PLACEHOLDER,
  profile: {
    id: null,
    userName: '',
    email: '',
    phoneNumber: '',
    nationality: '',
    dateOfBirth: '',
    profilePicture: '',
    driverType: '',
    drivingLicenseNumber: '',
    nationalId: '',
    role: '',
    roleId: null,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Role: { roleName: '' },
    assignmentStatus: '',
    kycStatus: '',
    status: '',
    isAvailable: false,
    isVerified: false,
    preferredLanguage: '',
    notificationPreference: { sms: false, email: false, whatsapp: false },
    documents: [
      {
        documentName: '',
        filePath: '',
        isAdditional: false,
        status: '',
        type: '',
      },
    ],
    otp: '',
    otpExpiry: '',
    resetPasswordToken: '',
    resetTokenExpiry: '',
    createdAt: '',
    updatedAt: '',
  },
  pricingSettings: {
    kmAllowance: 0,
    superCollisionCost: 0,
    carDeliveryCost: 0,
    unlimitedKMAllownceCost: 0,
    pricingArray: [],
    extras: [
      {
        id: 0,
        type: '',
        price: '',
        range: 0,
        code: '',
        typeAr: '',
      },
    ],
  },
  isAssignDriverOpen: false,
  assignDriverBooking: {
    id: 0,
    pickupDate: '',
    dropoffDate: '',
    extras: [
      {
        id: 0,
        type: '',
        price: '',
        range: 0,
        code: '',
        typeAr: '',
      },
    ],
    driverStatus: '',
    chaufferDriverCount: 0,
  },
  selectedListTabs: {},
};
